module.exports = __webpack_public_path__ + "static/img/img-honor3.60f3b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-honor3.png
// module id = YcEw
// module chunks = 1